export const languages = [
    { label: 'English', code: 'default', flag: '🇬🇧' },
    { label: 'Español', code: 'es', flag: '🇪🇸' },
    { label: 'Français', code: 'fr', flag: '🇫🇷' },
    { label: 'Deutsch', code: 'de', flag: '🇩🇪' },
    { label: 'العربية', code: 'ar', flag: '🇸🇦' },
    { label: '简体中文', code: 'zh-Hans', flag: '🇨🇳' },
    { label: '繁體中文', code: 'zh-Hant', flag: '🇹🇼' },
    { label: '日本語', code: 'ja', flag: '🇯🇵' },
    { label: '한국어', code: 'ko', flag: '🇰🇷' },
    { label: 'Português', code: 'pt', flag: '🇵🇹' },
    { label: 'Русский', code: 'ru', flag: '🇷🇺' },
    { label: 'हिन्दी', code: 'hi', flag: '🇮🇳' },
    { label: 'Nederlands', code: 'nl', flag: '🇳🇱' },
    { label: 'Italiano', code: 'it', flag: '🇮🇹' },
    { label: 'Svenska', code: 'sv', flag: '🇸🇪' },
    { label: 'Dansk', code: 'da', flag: '🇩🇰' },
    { label: 'Norsk', code: 'no', flag: '🇳🇴' },
    { label: 'Polski', code: 'pl', flag: '🇵🇱' },
    { label: 'Türkçe', code: 'tr', flag: '🇹🇷' },
    { label: 'Tiếng Việt', code: 'vi', flag: '🇻🇳' },
    { label: 'Bahasa Indonesia', code: 'id', flag: '🇮🇩' },
    { label: 'Čeština', code: 'cs', flag: '🇨🇿' },
    { label: 'Ελληνικά', code: 'el', flag: '🇬🇷' },
    { label: 'Magyar', code: 'hu', flag: '🇭🇺' },
    { label: 'ไทย', code: 'th', flag: '🇹🇭' },
    { label: 'Українська', code: 'uk', flag: '🇺🇦' },
    { label: 'Suomi', code: 'fi', flag: '🇫🇮' },
    { label: 'עברית', code: 'he', flag: '🇮🇱' },
    { label: 'Română', code: 'ro', flag: '🇷🇴' },
    { label: 'Català', code: 'ca', flag: '🇦🇩' },
    { label: 'Hrvatski', code: 'hr', flag: '🇭🇷' },
    { label: 'Slovenčina', code: 'sk', flag: '🇸🇰' },
    { label: 'Български', code: 'bg', flag: '🇧🇬' },
    { label: 'Slovenščina', code: 'sl', flag: '🇸🇮' },
    { label: 'Filipino', code: 'fil', flag: '🇵🇭' },
    { label: 'Bahasa Melayu', code: 'ms', flag: '🇲🇾' },
    { label: 'Kiswahili', code: 'sw', flag: '🇰🇪' },
    { label: 'Српски', code: 'sr', flag: '🇷🇸' },
    { label: 'Lietuvių', code: 'lt', flag: '🇱🇹' },
    { label: 'Latviešu', code: 'lv', flag: '🇱🇻' },
    { label: 'Eesti', code: 'et', flag: '🇪🇪' },
    { label: 'فارسی', code: 'fa', flag: '🇮🇷' },
    { label: 'ਪੰਜਾਬੀ', code: 'pa', flag: '🇮🇳' },
    { label: 'தமிழ்', code: 'ta', flag: '🇮🇳' },
    { label: 'తెలుగు', code: 'te', flag: '🇮🇳' },
    { label: 'मराठी', code: 'mr', flag: '🇮🇳' },
    { label: 'বাংলা', code: 'bn', flag: '🇧🇩' },
    { label: 'اردو', code: 'ur', flag: '🇵🇰' },
] as const;
export type LanguageCode = (typeof languages)[number]['code'];

export const getLanguageLabel = (value: LanguageCode): (typeof languages)[number]['label'] | 'unknown' => {
    const language = languages.find((lang) => lang.code === value);
    return language ? language.label : 'unknown';
};
